"use strict";

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOAuthPopup = exports.defaultErrorHandler = void 0;

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var ERROR_GUIDANCES = {
  unauthorized_client: 'This likely means our integration is not properly setup with your district. Please have a district IT ' + 'administrator reach out to support.',
  invalid_client: 'This likely means our integration is not properly setup with your district. Please have a district IT ' + 'administrator reach out to support.',
  temporarily_unavailable: "This likely means we're having trouble contacting your integration. Please wait a few minutes and try again.",
  invalid_scope: 'This likely means our integration is not properly setup with your district. Specifically, we appear to be missing ' + 'a few scopes. Please have a district IT administrator review our support documentation for this integration and ' + 'make sure their configuration is correct. Alternatively, they can reach out to support and our support team will ' + 'be happy to help.'
};

function defaultErrorHandler(err) {
  antd_1.Modal.error({
    title: 'There seems to be a problem with this integration.',
    content: react_1.default.createElement("div", {
      style: {
        marginTop: 16
      }
    }, react_1.default.createElement("p", null, "When trying to authenticate, we ran into a", ' ', react_1.default.createElement(antd_1.Typography.Text, {
      code: true
    }, err.error), " error."), ERROR_GUIDANCES[err.error] ? react_1.default.createElement("p", null, ERROR_GUIDANCES[err.error]) : null, err.description ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("p", null, "Additionally, the following information came back from the integrating partner and might be helpful:"), react_1.default.createElement("p", {
      style: {
        opacity: 0.75
      }
    }, err.description)) : null, react_1.default.createElement("p", null, "Sometimes simply trying again fixes the issue. If the issue persists, please reach out to support and we'll be glad to help.")),
    width: 600,
    bodyStyle: {
      maxWidth: '90vw'
    }
  });
}

exports.defaultErrorHandler = defaultErrorHandler;

function getPopupUrl(_ref) {
  var _params = _ref.params,
      clientId = _ref.clientId,
      scopes = _ref.scopes,
      redirectUri = _ref.redirectUri,
      additionalParams = _ref.additionalParams,
      authorizeUrl = _ref.authorizeUrl;
  var params = new URLSearchParams(_params || Object.assign({
    client_id: clientId,
    scope: scopes.join(' '),
    redirect_uri: redirectUri,
    response_type: 'code'
  }, additionalParams));
  return "".concat(authorizeUrl, "?").concat(params.toString());
}

var createPopup = function createPopup(props) {
  var title = props.title,
      height = props.height,
      width = props.width;
  var left = window.screenX + (window.outerWidth - width) / 2;
  var top = window.screenY + (window.outerHeight - height) / 2.5;
  var externalPopup = window.open(getPopupUrl(props), title, "width=".concat(width, ",height=").concat(height, ",left=").concat(left, ",top=").concat(top));
  return externalPopup;
};

function useOAuthPopup(_a) {
  var onCode = _a.onCode,
      onClose = _a.onClose,
      _a$onError = _a.onError,
      onError = _a$onError === void 0 ? defaultErrorHandler : _a$onError,
      modalProps = __rest(_a, ["onCode", "onClose", "onError"]);

  var _react_1$default$useS = react_1.default.useState(),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      externalWindow = _react_1$default$useS2[0],
      setExternalWindow = _react_1$default$useS2[1];

  var intervalRef = react_1.default.useRef();
  var onCodeRef = react_1.default.useRef(onCode);
  var onErrorRef = react_1.default.useRef(onError);

  var clearTimer = function clearTimer() {
    window.clearInterval(intervalRef.current);
  };

  var onContainerClick = function onContainerClick() {
    var _a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var onCode = _a.onCode,
        _modalProps = __rest(_a, ["onCode"]);

    onCodeRef.current = onCode;
    setExternalWindow(createPopup(Object.assign(Object.assign({}, modalProps), _modalProps)));
  };

  react_1.default.useEffect(function () {
    onCodeRef.current = onCode;
  }, [onCode]);
  react_1.default.useEffect(function () {
    onErrorRef.current = onError;
  }, [onError]);
  react_1.default.useEffect(function () {
    if (externalWindow) {
      intervalRef.current = window.setInterval(function () {
        var success = false;

        try {
          var currentUrl = externalWindow.location.href;
          var params = new URL(currentUrl).searchParams;
          var code = params.get('code') || params.get('oauth_token');
          var error = params.get('error');

          if (code) {
            if (onCodeRef.current) {
              onCodeRef.current(code, params);
              if (externalWindow) externalWindow.close();
              success = true;
            }
          } else if (error) {
            var oauthError = {
              error: error,
              description: params.get('error_description') || undefined
            };

            if (onErrorRef.current) {
              onErrorRef.current(oauthError);
              setExternalWindow(null);
            }
          } else {
            return;
          }

          clearTimer();
        } catch (error) {// eslint-ignore-line
        } finally {
          if ((!externalWindow || externalWindow.closed) && !success) {
            onClose();
            clearTimer();
          }
        }
      }, 700);
      return function () {
        if (externalWindow) externalWindow.close();
        if (onClose) onClose();
      };
    }
  }, [externalWindow]);
  return {
    onContainerClick: onContainerClick,
    closePopup: function closePopup() {
      setExternalWindow(null);
    }
  };
}

exports.useOAuthPopup = useOAuthPopup;